/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateFragmentSocialUploadsMutationRequest, CreateFragmentSocialUploadsMutationResponse } from "../models/CreateFragmentSocialUploads";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createFragmentSocialUploads } from "../axios/createFragmentSocialUploads";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createFragmentSocialUploadsMutationKey = () => ["web-app-bff-api", { url: '/fragment-social-uploads' }] as const

export type CreateFragmentSocialUploadsMutationKey = ReturnType<typeof createFragmentSocialUploadsMutationKey>

export function createFragmentSocialUploadsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateFragmentSocialUploadsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createFragmentSocialUploadsMutationKey()
        return mutationOptions<CreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<Error>, {data: CreateFragmentSocialUploadsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createFragmentSocialUploads(data, config)
          },
        })

}

/**
 * @summary Start upload of fragment or video-editor project media to platform
 * {@link /fragment-social-uploads}
 */
export function useCreateFragmentSocialUploads<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<Error>, {data: CreateFragmentSocialUploadsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateFragmentSocialUploadsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createFragmentSocialUploadsMutationKey()

          const baseOptions = createFragmentSocialUploadsMutationOptions(config) as UseMutationOptions<CreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<Error>, {data: CreateFragmentSocialUploadsMutationRequest}, TContext>
          

          return useMutation<CreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<Error>, {data: CreateFragmentSocialUploadsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<Error>, {data: CreateFragmentSocialUploadsMutationRequest}, TContext>
      
}